import type { Translations } from './translation';

const translations: Translations = {
	ticket: 'Билет',
	ticketOptions: 'Опции за билет',
	includedInTicket: 'Включено в билета',
	journeyDetails: 'Детайли за пътуването',
	refreshItinerary: 'Обнови пътуването',
	transfers: 'прекачвания',
	walk: 'Пеша',
	bike: 'Велосипед',
	cargoBike: 'Товарен велосипед',
	scooterStanding: 'тротинетка',
	scooterSeated: 'тротинетка',
	car: 'Автомобил',
	taxi: 'Такси',
	moped: 'Скутер',
	unknownVehicleType: 'Неизвестен тип превозно средство',
	electricAssist: 'Електрическа помощ',
	electric: 'Електрически',
	combustion: 'Двигател с вътрешно горене',
	combustionDiesel: 'Дизел',
	hybrid: 'Хибрид',
	plugInHybrid: 'Зареждаем хибрид',
	hydrogenFuelCell: 'Водородна горивна клетка',
	from: 'От',
	to: 'До',
	myLocation: 'My location',
	reverseDirections: 'Reverse directions',
	viaStop: 'Междинна спирка',
	viaStops: 'Междинни спирки',
	addViaStop: 'Добави междинна спирка',
	removeViaStop: 'Премахни междинната спирка',
	viaStayDuration: 'Минимален престой',
	position: 'местоположение',
	arrival: 'Пристигане',
	departure: 'Заминаване',
	duration: 'Продължителност',
	arrivals: 'Пристигания',
	later: 'по-късно',
	earlier: 'по-рано',
	connections: 'Връзки',
	departures: 'Заминавания',
	switchToArrivals: 'Превключи към пристигания',
	switchToDepartures: 'Превключи към заминавания',
	track: 'Коловоз',
	platform: 'Перон',
	trackAbr: 'Кол.',
	platformAbr: 'Перон',
	arrivalOnTrack: 'Пристигане на коловоз',
	tripIntermediateStops: (n: number) => {
		switch (n) {
			case 0:
				return 'Без междинни спирки';
			case 1:
				return '1 междинна спирка';
			default:
				return `${n} междинни спирки`;
		}
	},
	sharingProvider: 'Оператор',
	sharingProviders: 'Оператори',
	none: 'Няма',
	returnOnlyAtStations: 'Превозното средство трябва да се върне на станция.',
	roundtripStationReturnConstraint: 'Превозното средство трябва да се върне на началната станция.',
	rentalStation: 'Станция',
	rentalGeofencingZone: 'Зона',
	noItinerariesFound: 'Не са намерени маршрути.',
	advancedSearchOptions: 'Разширени настройки',
	selectTransitModes: 'Изберете видове транспорт',
	defaultSelectedModes: 'Всички видове транспорт',
	defaultSelectedProviders: 'Всички превозвачи',
	selectElevationCosts: 'Избягвай стръмни наклони',
	wheelchair: 'Само безбариеpни връзки',
	hgvRoutingOptions: 'Опции за тежкотоварен автомобил',
	vehicleHeight: 'Височина на превозното средство (m)',
	vehicleWidth: 'Ширина на превозното средство (m)',
	vehicleLength: 'Дължина на превозното средство (m)',
	vehicleWeight: 'Тегло на превозното средство (t)',
	vehicleTopSpeed: 'Макс. скорост (km/h)',
	vehicleAxleCount: 'Брой оси',
	vehicleAxleLoad: 'Натоварване на ос (t)',
	vehicleHazmat: 'Опасни товари',
	vehicleHazmatWater: 'Опасни за водата товари',
	vehicleTrailer: 'С ремарке',
	vehicleLezAccess: 'Достъп до нискоемисионни зони',
	useRoutedTransfers: 'Използвай посочените прекачвания',
	bikeRental: 'наемане на велосипед',
	requireBikeTransport: 'Превоз на велосипед',
	requireCarTransport: 'Превоз на автомобил',
	noCompulsoryReservation: 'No reservation required',
	considerRentalReturnConstraints: 'Върни наетите превозни средства в рамките на пътуването',
	default: 'По подразбиране',
	timetableSources: 'Източници на разписания',
	tripCancelled: 'Пътуването е отменено',
	stopCancelled: 'Спирката е отменена',
	addStop: 'Добави спирка',
	inOutDisallowed: 'Качване/слизане не е позволено',
	inDisallowed: 'Качването не е позволено',
	outDisallowed: 'Слизането не е позволено',
	unscheduledTrip: 'извънреден курс',
	alertsAvailable: 'налични известия',
	dataExpiredSince: 'Данните са остарели, последно валидни на',
	FLEX: 'По заявка',
	WALK: 'Пеша',
	BIKE: 'Велосипед',
	RENTAL: 'Нает',
	RIDE_SHARING: 'Споделено пътуване',
	CAR: 'Автомобил',
	HGV: 'Тежкотоварен автомобил',
	CAR_DROPOFF: 'Слизане от автомобила',
	CAR_PARKING: 'Паркинг (P+R)',
	TRANSIT: 'Градски транспорт',
	TRAM: 'Трамвай',
	SUBWAY: 'Метро',
	FERRY: 'Ферибот',
	AIRPLANE: 'Самолет',
	SUBURBAN: 'Градска железница',
	BUS: 'Автобус',
	COACH: 'Междуградски автобус',
	RAIL: 'Влак',
	HIGHSPEED_RAIL: 'Високоскоростен влак',
	LONG_DISTANCE: 'Междуградски влак',
	NIGHT_RAIL: 'Нощен влак',
	REGIONAL_FAST_RAIL: 'Бърз регионален влак',
	ODM: 'По заявка',
	REGIONAL_RAIL: 'Регионален влак',
	OTHER: 'Други',
	routingSegments: {
		maxTransfers: 'Макс. прекачвания',
		maxTravelTime: 'Макс. време за пътуване',
		firstMile: 'Първи километър',
		lastMile: 'Последен километър',
		direct: 'Директна връзка',
		maxPreTransitTime: 'Максимално време преди транзит',
		maxPostTransitTime: 'Максимално време след транзит',
		maxDirectTime: 'Максимално време без транзит',
		additionalTransferTime: 'Допълнително време за прехвърляне',
		pedestrianSpeed: 'Скорост на пешеходец',
		cyclingSpeed: 'Скорост на велосипедист',
		transferTimeFactor: 'Фактор на времето за прехвърляне'
	},
	elevationCosts: {
		NONE: 'Без наклон',
		LOW: 'Лек наклон',
		HIGH: 'Голям наклон'
	},
	isochronesOpacity: 'Непрозрачност на периметъра',
	isochrones: {
		title: 'Достъпен периметър',
		styling: 'Стил',
		noData: 'Няма данни',
		requestFailed: 'Заявката е неуспешна'
	},
	alerts: {
		validFrom: 'Валидно от',
		until: 'до',
		information: 'Информация',
		more: 'още'
	},
	RENTAL_BICYCLE: 'Споделен велосипед',
	RENTAL_CARGO_BICYCLE: 'Споделен товарен велосипед',
	RENTAL_CAR: 'Нает автомобил',
	RENTAL_MOPED: 'Споделен скутер',
	RENTAL_SCOOTER_STANDING: 'Споделена тротинетка',
	RENTAL_SCOOTER_SEATED: 'Споделена седяща тротинетка',
	RENTAL_OTHER: 'Друго споделено превозно средство',
	incline: 'Наклон',
	CABLE_CAR: 'Въжен лифт',
	FUNICULAR: 'Фуникулер',
	AERIAL_LIFT: 'Въздушен лифт',
	toll: 'Внимание! Платен път.',
	bikesAllowed: 'Bikes allowed',
	wheelchairAccessible: 'Wheelchair accessible',
	compulsoryReservation: 'Reservation necessary',
	accessRestriction: 'забранен достъп',
	continuesAs: 'Продължава като',
	earlierAlternatives: 'По-ранни алтернативи',
	laterAlternatives: 'По-късни алтернативи',
	differentStops: 'Различни спирки',
	rent: 'Наем',
	copyToClipboard: 'Копирай в клипборда',
	rideThroughAllowed: 'Минаване е позволено',
	rideThroughNotAllowed: 'Минаване не е позволено',
	rideEndAllowed: 'Паркиране е позволено',
	rideEndNotAllowed: 'Паркиране не е позволено',
	DEBUG_BUS_ROUTE: 'Маршрут на автобус (Отстраняване на грешки)',
	DEBUG_RAILWAY_ROUTE: 'Маршрут на влак (Отстраняване на грешки)',
	DEBUG_FERRY_ROUTE: 'Маршрут на ферибот (Отстраняване на грешки)',
	colorMode: {
		none: 'No Map Visualization',
		stops: 'Stops',
		rt: 'Timetable: Delays',
		route: 'Timetable: Line Colors',
		mode: 'Timetable: Transport Modes'
	},
	resetToNorth: 'Reset to north',
	showMyLocation: 'Show my location',
	toggleHillshades: 'Toggle hillshades overlay',
	routes: (n: number) => {
		switch (n) {
			case 0:
				return 'Без маршрут';
			case 1:
				return '1 маршрут';
			default:
				return `${n} маршрута`;
		}
	},
	pageTitle: {
		default: 'MOTIS',
		fromTo: (from, to) => `${from} до ${to}`,
		departuresAt: (stop) => `Заминавания от ${stop}`,
		arrivalsAt: (stop) => `Пристигания в ${stop}`,
		isochronesFrom: (place) => `Достъпен периметър от ${place}`
	},
	tickets: 'Билети',
	routeInformation: 'Допълнителна информация'
};

export default translations;
